import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Logo } from "../components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    if (!sessionId) {
      setState({ loading: false, data: null, error: "Sessione di pagamento mancante." });
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState({ loading: false, data, error: null });
        } else if (attempts < 5) {
          attempts += 1;
          setTimeout(poll, 2000);
        } else {
          setState({ loading: false, data, error: null });
        }
      } catch (e) {
        console.error(e);
        setState({ loading: false, data: null, error: "Impossibile verificare il pagamento." });
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="bg-[#0d0718] text-[#ede8f5] min-h-screen flex flex-col">
      <div className="px-6 py-6 border-b border-[#2d1b4e]">
        <div className="max-w-6xl mx-auto"><Logo /></div>
      </div>
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-md w-full text-center p-8 rounded-2xl bg-[#120a21] border border-[#2d1b4e]">
          {state.loading && (
            <>
              <Loader2 data-testid="payment-loading" className="w-12 h-12 text-[#a020f0] animate-spin mx-auto mb-4" />
              <h1 className="text-xl font-bold text-white mb-2">Verifica del pagamento in corso...</h1>
              <p className="text-sm text-[#94a3b8]">Stiamo confermando la transazione con Stripe.</p>
            </>
          )}
          {!state.loading && state.error && (
            <>
              <XCircle data-testid="payment-error" className="w-12 h-12 text-red-400 mx-auto mb-4" />
              <h1 className="text-xl font-bold text-white mb-2">Qualcosa non va</h1>
              <p className="text-sm text-[#94a3b8] mb-6">{state.error}</p>
              <Link to="/contatti" data-testid="payment-error-contact"
                className="inline-block px-6 py-3 rounded-xl bg-[#1e1038] border border-[#a020f0]/30 text-white text-xs font-bold uppercase tracking-wider">
                Contattaci
              </Link>
            </>
          )}
          {!state.loading && !state.error && state.data?.payment_status === "paid" && (
            <>
              <CheckCircle2 data-testid="payment-confirmed" className="w-12 h-12 text-[#38bdf8] mx-auto mb-4" />
              <h1 className="display-font text-2xl uppercase text-white mb-2">Pagamento Completato</h1>
              <p className="text-sm text-[#cbd5e1] mb-2">
                {state.data.package_name ? `Hai acquistato: ${state.data.package_name}.` : "Acquisto confermato."}
              </p>
              <p className="text-xs text-[#94a3b8] mb-6">
                Riceverai a breve un'email con le istruzioni per attivare l'app e compilare il questionario iniziale. Benvenuto nel percorso.
              </p>
              <Link to="/" data-testid="payment-success-home"
                className="inline-block px-8 py-3.5 rounded-xl bg-gradient-to-r from-[#6a0dad] to-[#a020f0] text-white font-bold text-xs uppercase tracking-wider">
                Torna alla Home
              </Link>
            </>
          )}
          {!state.loading && !state.error && state.data && state.data.payment_status !== "paid" && (
            <>
              <Loader2 className="w-12 h-12 text-[#a020f0] mx-auto mb-4" />
              <h1 className="text-xl font-bold text-white mb-2">Pagamento in elaborazione</h1>
              <p className="text-sm text-[#94a3b8] mb-6">
                La conferma sta richiedendo più tempo del previsto. Riceverai un'email appena completato.
              </p>
              <Link to="/" data-testid="payment-pending-home" className="text-xs text-[#a78bfa] hover:text-white underline">
                Torna alla home
              </Link>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
